import { SchoolWizard } from './SchoolWizard';

export function SchoolCreatePage() {
  return <SchoolWizard mode="create" />;
}
